/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConnectedAccountResponse
 */
export interface GetConnectedAccountResponse {
    /**
     * The user ID associated with the provided Discord member ID
     * @type {string}
     * @memberof GetConnectedAccountResponse
     */
    userId?: string;
}

export function GetConnectedAccountResponseFromJSON(json: any): GetConnectedAccountResponse {
    return GetConnectedAccountResponseFromJSONTyped(json, false);
}

export function GetConnectedAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConnectedAccountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function GetConnectedAccountResponseToJSON(value?: GetConnectedAccountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
    };
}


